<div id="sidebar-cart" class="offcanvas offcanvas-end">
  <div class="offcanvas-header mt-3 mx-2">
    <div class="flex-grow-1">
      <h4 class="mb-0" i18n="@@NavTopMenuCartMenuTitle">Shopping Cart</h4>
    </div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <app-cart-preview></app-cart-preview>
  </div>
</div>
